<div class="section-holder">
  <CheckoutAddress ref="checkoutAddress" />
  <PaymentMethods />
  <ShippingMethods />
  <div class="section packaging" v-if="showWrappingSelection">
    <div class="heading-holder">
      <div class="heading-primary">{{ $t('shopping.basket.checkout.packaging') }}</div>
      <NBPopover>
        <template #trigger>
          <span class="iconfont-info-filled"></span>
        </template>
      
        <template #content>
          <img :src="image" alt="Packaging box" />
        </template>
      </NBPopover>
    </div>
    <Packaging />
  </div>
</div>
<div class="section-holder">
  <CartItems />
</div>
